import { render, staticRenderFns } from "./head-logistics-base.vue?vue&type=template&id=a85b1364&scoped=true&"
import script from "./head-logistics-base.vue?vue&type=script&lang=js&"
export * from "./head-logistics-base.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85b1364",
  null
  
)

export default component.exports